











































import {Component, Vue} from 'vue-property-decorator';

import {CAC_LINKS} from '@/menu/constants';

import ClickAndCollect from '../views/ClickAndCollect.vue';
import BaseService from './BaseService.vue';
import Iframe from './Iframe.vue';

@Component({
  components: {
    ClickAndCollect,
    Iframe,
  },
})
export default class MultiClickAndCollectLinks extends BaseService {
  clickAndCollectLinks = CAC_LINKS;

  currentUrl: string | null = null;

  selectSource(url: string): void {
    if (this.accessToken) {
      this.currentUrl = `${url}&autoLoginByAccessToken=${this.accessToken}`;
    } else {
      this.currentUrl = url;
    }
  }

  mounted(): void {
    if (this.clickAndCollectLinks && this.accessToken) {
      this.currentUrl = `${this.clickAndCollectLinks[0].link}&autoLoginByAccessToken=${this.accessToken}`;
    } else if (this.clickAndCollectLinks) {
      this.currentUrl = this.clickAndCollectLinks[0].link;
    }
  }
}
